import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as translationService from '../../services/translationService'
import { getCurrentStepType } from '../../services/stepService'
import CardSelector from '../../components/CardSelector'
import { Stepper, TextContainer, Caption, DisplayText, Icon } from './../../components'
import { updateApplicationInformation, softUpdateApplicationInformation } from '../../actions/FlowAction'
import SceneComponent from './SceneComponent'

class ResidentsScene extends SceneComponent {
  static propTypes = {
    updateApplicationInformation: PropTypes.any,
    onRef: PropTypes.any,
    step: PropTypes.any,
    application: PropTypes.any,
    firstname: PropTypes.any,
  }

  state = {
    types: [],
    values: [],
  }

  handleAdd = typeIds => {
    const types = this.getTypes(this.props.step)
    const values = this.props.application.residents
    typeIds.forEach(typeId => {
      const type = types.find(type => type.id === typeId)
      values.push({
        id: type.id,
        value: type.min,
      })
    })
    this.props.softUpdateApplicationInformation({
      residents: values,
    })
  }

  handleRemove = typeId => {
    let values = this.props.application.residents
    values = values.filter(value => value.id !== typeId)
    this.props.softUpdateApplicationInformation({
      residents: values,
    })
  }

  handleChange = (typeId, newValue) => {
    const values = this.props.application.residents
    values.map(value => {
      if (value.id === typeId) value.value = newValue
      return value
    })

    this.props.softUpdateApplicationInformation({
      residents: values,
    })
  }

  onSubmit = () => {
    const { residents } = this.props.application
    return this.props.updateApplicationInformation({ residents })
  }

  componentDidMount(...args) {
    super.componentDidMount.apply(this, args)
  }

  getTypes = step => {
    const stepType = getCurrentStepType(step)

    const types = [
      {
        id: 'INTAKE_RESIDENT_ADULTS',
        persist: true,
        icon: <Icon source="adults" />,
        min: 1,
      },
      {
        id: 'INTAKE_RESIDENT_CHILDREN',
        persist: true,
        icon: <Icon source="children" />,
        min: 0,
      },
    ]
    const otherTypes = [
      {
        id: 'INTAKE_PETS_DOGS',
        icon: <Icon source="dog" />,
        min: 1,
      },
      {
        id: 'INTAKE_PETS_CATS',
        icon: <Icon source="cat" />,
        min: 1,
      },
      {
        id: 'INTAKE_PETS_FISH',
        icon: <Icon source="fish" />,
        min: 1,
      },
      {
        id: 'INTAKE_PETS_RODENTS',
        icon: <Icon source="rodent" />,
        min: 1,
      },
      {
        id: 'INTAKE_PETS_BIRDS',
        icon: <Icon source="bird" />,
        min: 1,
      },
      {
        id: 'INTAKE_PETS_CHICKENS',
        icon: <Icon source="chicken" />,
        min: 1,
      },
      {
        id: 'INTAKE_PETS_REPTILES',
        icon: <Icon source="reptile" />,
        min: 1,
      },
      {
        id: 'INTAKE_PETS_OTHER',
        icon: <Icon source="animal" />,
        min: 1,
      },
    ]

    return stepType === 'VISIT_REQUEST_STEPS' ? types : [...types, ...otherTypes]
  }

  render() {
    const types = this.getTypes(this.props.step)

    const { residents } = this.props.application || []
    return (
      <TextContainer>
        {!this.props.inModal && <DisplayText>{translationService.residentTitle(this.props.firstname)}</DisplayText>}
        <DisplayText size="small">{translationService.residentSubTitle()}</DisplayText>
        <Caption>{translationService.residentCaption()}</Caption>

        <div>
          {types.length && (
            <CardSelector
              id="types"
              values={residents}
              onAdd={this.handleAdd}
              onChange={this.handleChange}
              onRemove={this.handleRemove}
              types={types}
              title={translationService.residentAddPetsTitle()}
              action={translationService.residentAddPetsAction()}
              field={<Stepper />}
            />
          )}
        </div>
      </TextContainer>
    )
  }
}

const mapStateToProps = ({ FlowReducer, AuthReducer }) => {
  const { application, step } = FlowReducer
  const { user } = AuthReducer
  return {
    step,
    application,
    firstname: user.firstname,
  }
}
const mapDispatchToProps = dispatch => ({
  updateApplicationInformation: information => dispatch(updateApplicationInformation(information)),
  softUpdateApplicationInformation: information => dispatch(softUpdateApplicationInformation(information)),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ResidentsScene)



// WEBPACK FOOTER //
// ./src/views/scenes/ResidentsScene.js